/**
 * Gate 1 — Step 1: Trust Attribute Weighting REST client.
 */
import axios from "axios";
import { API_BASE_URL } from "../config";

const base = (projectId) => `${API_BASE_URL}/projects/${projectId}/gate1/trust-weights`;

export async function fetchTrustWeights(projectId) {
  const res = await axios.get(base(projectId));
  return res.data;
}

export async function generateTrustWeights(projectId) {
  const res = await axios.post(`${base(projectId)}/generate`);
  return res.data;
}

export async function saveTrustWeights(projectId, payload) {
  const res = await axios.put(base(projectId), payload);
  return res.data;
}
